<template>
  <div class="create-edit-pet-modal petit-nature-modal">
    <div class="header">
      <h1 class="subtitle is-4" v-if="isCreatePet">Novo pet</h1>
      <h1 class="subtitle is-4" v-else>Editar pet</h1>
      <span class="close-button" @click="$emit('close')">
        <i class="mdi mdi-window-close"></i>
      </span>
    </div>
    <form
      action=""
      class="body"
      novalidate
      @submit.prevent="validateBeforeSubmit"
    >
      <div class="columns is-multiline is-variable">
        <div class="column is-12">
          <label class="label">Dono</label>
          <b-field>
            <b-autocomplete
              expanded
              v-model="ownerSearchText"
              :data="ownersList"
              placeholder="Buscar dono"
              field="name"
              :loading="isFetching"
              :keep-first="true"
              @keyup.native="getOwnerAsyncData"
              @select="option => (selectedOwner = option)"
            >
              <template slot-scope="props">
                <span>{{ props.option.name }}</span>
              </template>
              <template slot="empty">
                Nenhum resultado encontrado
              </template>
            </b-autocomplete>
          </b-field>
        </div>
        <div class="column is-6">
          <div class="field">
            <label class="label" for="petName">Nome</label>
            <div class="control">
              <input
                :disabled="!selectedOwner || !selectedOwner.name"
                type="text"
                class="input"
                id="petName"
                name="petName"
                v-model.trim="pet.name"
              />
              <span
                class="error-message"
                v-if="selectedOwner && selectedOwner.name && alreadyHasPetName"
                >{{ selectedOwner.name }} já possui um pet com esse nome</span
              >
            </div>
          </div>
        </div>
        <div class="column is-6">
          <div class="field">
            <label class="label" for="petBreed">Raça</label>
            <div class="control">
              <input
                type="text"
                class="input"
                id="petBreed"
                name="petBreed"
                v-model.trim="pet.breed"
              />
            </div>
          </div>
        </div>
<!--        <div class="column is-6">
          <b-field label="Inicio AN">
            <b-datepicker v-model="pet.anstart" icon="calendar-today">
            </b-datepicker>
          </b-field>
        </div>-->
        <div class="column is-6">
          <b-field label="Data de nascimento">
            <b-datepicker v-model="pet.dateOfBirth" icon="calendar-today">
            </b-datepicker>
          </b-field>
        </div>
        <div class="column is-6">
          <b-field label="Idade">
            <span>{{getAge()}}</span>
          </b-field>
        </div>
        <div class="column is-6">
          <label class="label" for="petConsumption">Consumo</label>
          <b-field>
            <input
              type="number"
              class="input"
              id="petConsumption"
              name="petConsumption"
              v-model.trim="pet.consumption"
            />
            <p class="control">
              <a class="button is-primary">g</a>
            </p>
          </b-field>
        </div>
        <div class="column is-9">
          <div class="field">
            <b-checkbox v-model="pet.enableDelivery"
              >Habilitar entrega</b-checkbox
            >
          </div>
        </div>
        <div class="column is-9">
          <label class="label">Adicionar restrições</label>
          <b-field>
            <b-autocomplete
              expanded
              v-model="ingredientSearchText"
              :data="ingredientsList"
              placeholder="Buscar Ingrediente"
              field="name"
              :loading="isFetching"
              :keep-first="true"
              @keyup.native="getIngredientAsyncData"
              @select="option => (selectedIngredient = option)"
            >
              <template slot-scope="props">
                <span>{{ props.option.name }}</span>
                <span> ({{ props.option.category.name }})</span>
              </template>
              <template slot="empty">
                Nenhum resultado encontrado
              </template>
            </b-autocomplete>
            <p class="control">
              <a class="button is-primary" @click="addRestriction">+</a>
            </p>
          </b-field>
        </div>
        <div class="column is-12" v-if="pet.ingredients.length">
          <label class="label">Restrições do pet</label>
          <table class="table is-fullwidth">
            <thead>
              <tr>
                <th>Ingrediente</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="restriction in pet.ingredients" :key="restriction.id">
                <td>
                  {{ restriction.name }}
                </td>
                <td>
                  <a @click="removeRestriction(restriction)">Remover</a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="column is-12" v-else>
          <div class="no-items-message has-text-centered is-centered">
            Esse pet não possui restrições
          </div>
        </div>
      </div>
      <div class="columns is-multiline is-variable">
        <div class="column is-12 has-text-right">
          <button
            type="submit"
            class="button is-medium primary"
            :class="{ 'is-loading': isPendingAction }"
            :disabled="isPendingAction || pet.name === '' || alreadyHasPetName || !selectedOwner || !selectedOwner.name"
          >
            <span v-if="isCreatePet">Adicionar</span>
            <span v-else>Salvar</span>
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import IngredientService from "../../services/IngredientService";
import QueryBuilder from "../../helpers/QueryBuilder";
import utils from "../../helpers/debounce";
import BField from "buefy/src/components/field/Field";
import { mapActions } from "vuex";
import NotificationsWrapper from "../../helpers/NotificationsWrapper";
import CustomerService from "../../services/CustomerService";
import * as moment from "moment";

export default {
  name: "CreatePetComponent",
  components: { BField },
  props: { petParam: {} },
  data: function() {
    return {
      isCreatePet: true,
      pet: {
        name: "",
        ingredients: [],
        consumption: 0,
        enableDelivery: true,
        age: 0,
        breed: "",
        anstart: new Date(),
        dateOfBirth: new Date()
      },
      ingredientsList: [],
      isFetching: false,
      ingredientSearchText: "",
      selectedIngredient: {},
      isPendingAction: false,
      ownerSearchText: "",
      ownersList: [],
      selectedOwner: {},
      alreadyHasPetName: false
    };
  },
  watch: {
    "pet.name": function(val) {
      if (this.selectedOwner && this.isCreatePet) {
        this.alreadyHasPetName = this.selectedOwner.pets.some(
          v => val.toUpperCase() === v.name.toUpperCase()
        );
      }
    }
  },
  methods: {
    ...mapActions({
      createPet: "pet/createPet",
      editPet: "pet/editPet"
    }),
    getAge() {
      if (!this.pet.dateOfBirth){
        return;
      }
      const years = moment().diff(this.pet.dateOfBirth, "years");
      const months = moment().diff(this.pet.dateOfBirth, "months") - years * 12;
      return `${years} anos e ${months} meses`;
    },
    getIngredientAsyncData: utils.debounce(function() {
      this.ingredientsList = [];
      let query = {
        name: this.ingredientSearchText,
        size: 5
      };
      query = QueryBuilder.getQueryString(query);
      this.isFetching = true;
      IngredientService.getIngredients(query)
        .then(({ data }) => {
          this.ingredientsList = data.content;
        })
        .finally(() => (this.isFetching = false));
    }, 300),
    getOwnerAsyncData: utils.debounce(function() {
      this.ownersList = [];
      let query = {
        name: this.ownerSearchText,
        size: 5
      };
      query = QueryBuilder.getQueryString(query);
      this.isFetching = true;
      CustomerService.getCustomers(query)
        .then(({ data }) => {
          this.ownersList = data.content;
        })
        .finally(() => (this.isFetching = false));
    }, 300),
    validateBeforeSubmit() {
      if (this.isCreatePet) {
        this.pet.owner = this.selectedOwner;
        this.isPendingAction = true;
        this.createPet(this.pet)
          .then(() => {
            NotificationsWrapper.success("Pet criado com sucesso");
            this.isPendingAction = false;
            this.$emit("close");
          })
          .catch(r => {
            NotificationsWrapper.error("Houve um erro ao criar o pet");
            this.isPendingAction = false;
          });
      } else {
        this.editPet(this.pet)
          .then(() => {
            NotificationsWrapper.success("Pet editado com sucesso");
            this.isPendingAction = false;
            this.$emit("close");
          })
          .catch(r => {
            NotificationsWrapper.error("Houve um erro ao editar o pet");
            this.isPendingAction = false;
          });
      }
    },
    addRestriction() {
      let alreadyExist = false;
      if (!this.selectedIngredient.name) {
        this.ingredientSearchText = "";
        return;
      }
      this.pet.ingredients.forEach(ing => {
        if (ing.id === this.selectedIngredient.id) {
          alreadyExist = true;
        }
      });
      if (alreadyExist) {
        return;
      }
      this.pet.ingredients.push(this.selectedIngredient);
      this.ingredientSearchText = "";
    },
    removeRestriction(restriction) {
      this.pet.ingredients = this.pet.ingredients.filter(ing => {
        return ing.id !== restriction.id;
      });
    }
  },
  created() {
    if (!this.petParam.id) {
      this.isCreatePet = true;
    } else {
      this.pet = this.petParam;
      if (this.pet.anstart === null) {
        this.pet.anstart = new Date();
        this.pet.dateOfBirth = new Date();
      } else {
        this.pet.anstart = this.petParam.anstart
          ? new Date(this.petParam.anstart)
          : null;
        this.pet.dateOfBirth = this.petParam.dateOfBirth
          ? new Date(this.petParam.dateOfBirth)
          : null;
      }
      this.ownerSearchText = this.pet.owner.name;
      this.selectedOwner = this.pet.owner;
      this.isCreatePet = false;
    }
  }
};
</script>

<style scoped></style>
